import { ColorToken, OuiTextComponent } from '@aiz-gl/omni-ui';
import { Component, HostBinding, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { css } from '@emotion/css';

const CHECKBOX_STYLES = {
  GAP: 8,
  BORDER_WIDTH: 1,
  STROKE_WIDTH: 3,
  STROKE_DASH_ARRAY: 18,
  COLORS: {
    BORDER: '#b3b3b3',
    BACKGROUND: '#FFF',
    CHECK: '#008715',
    ERROR: '#ED2121',
  },
  TRANSITIONS: {
    DEFAULT: 'all 0.2s ease',
    CHECK: 'all 0.5s ease-in-out',
  },
} as const;

@Component({
  selector: 'app-checkbox',
  imports: [ReactiveFormsModule, OuiTextComponent],
  templateUrl: './checkbox.component.html',
  standalone: true,
})
export class CheckboxComponent {
  @HostBinding('class') className = css({ display: 'contents' });

  readonly form = input<FormGroup>(new FormGroup({}));
  readonly controlName = input<string>('');
  readonly label = input<string>('');
  readonly variant = input<ColorToken>('primary');
  readonly labelPosition = input<'before' | 'after'>('before');

  checkboxForm = css({
    display: 'contents',
  });

  checkboxLabel = css({
    userSelect: 'none',
    cursor: 'pointer',
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
    gap: CHECKBOX_STYLES.GAP,
    justifyContent: 'space-between',
    width: '100%',

    '&:hover .checkbox svg path': {
      strokeDashoffset: 0,
    },

    '& .checkbox svg': {
      display: 'block',
    },

    '& .checkbox svg path': {
      fill: CHECKBOX_STYLES.COLORS.BACKGROUND,
      stroke: CHECKBOX_STYLES.COLORS.BORDER,
      strokeWidth: CHECKBOX_STYLES.BORDER_WIDTH,
      transition: CHECKBOX_STYLES.TRANSITIONS.DEFAULT,
    },

    '& .checkbox svg polyline': {
      fill: 'none',
      stroke: CHECKBOX_STYLES.COLORS.CHECK,
      strokeWidth: CHECKBOX_STYLES.STROKE_WIDTH,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: CHECKBOX_STYLES.STROKE_DASH_ARRAY,
      strokeDashoffset: CHECKBOX_STYLES.STROKE_DASH_ARRAY,
      transition: CHECKBOX_STYLES.TRANSITIONS.CHECK,
    },

    '& oui-text, & span, & p': {
      whiteSpace: 'nowrap',
    },
  });

  checkboxLabelAfter = `${this.checkboxLabel} ${css({
    justifyContent: 'flex-start',
    width: 'auto',
  })}`;

  checkboxInput = css({
    position: 'absolute',
    zIndex: -1,
    width: 0,
    height: 0,
    opacity: 0,

    '&:checked + .checkbox': {
      borderColor: CHECKBOX_STYLES.COLORS.BORDER,
    },

    '&:checked + .checkbox svg path': {
      fill: CHECKBOX_STYLES.COLORS.BACKGROUND,
    },

    '&:checked + .checkbox svg polyline': {
      strokeDashoffset: 0,
    },
  });
}
